<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">公司列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="10">
          <el-button size="small" type="primary" @click="toAddCompany()" plain>
            <i class="fa fa-plus"></i> 添加公司
          </el-button>
        </el-col>
        <el-col :span="8" :offset="6">
          <el-input size="small" type="text" placeholder="请公司名称" v-model="searchFm.companyName">
            <el-button slot="append" size="small" @click="dosearch()" type="primary"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table class="list-table" :data="companyList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ page.pageSize * (page.pageNo - 1) + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="名字">
          <template slot-scope="scope">
            <el-button type="text" @click="toViewProject(scope.row.id)">{{ scope.row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="industry" label="所属行业" min-width="150"></el-table-column>
        <el-table-column prop="scale" label="公司规模" min-width="150"></el-table-column>
        <el-table-column prop="contact" label="联系人" min-width="100"></el-table-column>
        <el-table-column prop="phone" label="电话" min-width="130"></el-table-column>
        <el-table-column label="状态" min-width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==0" type="warning" effect="plain" size="small">审核中</el-tag>
            <el-tag v-if="scope.row.status==1" type="success" effect="plain" size="small">正常</el-tag>
            <el-tag v-if="scope.row.status==2" type="danger" effect="plain" size="small">已注销</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" @click.prevent="toViewProject(scope.row.id)" size="small"><i class="fa fa-futbol-o"></i> 查看项目</el-button>
            <el-button type="text" @click.prevent="toFindScheme(scope.row)" size="small"><i class="fa fa-file-pdf-o"></i> 查看方案</el-button>
            <el-button type="text" @click.prevent="doAudit(scope.row.id)" size="small" v-if="scope.row.status==0"><i class="fa fa-legal"></i> 审核</el-button>
            <el-button type="text" @click.prevent="toAddCompany(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click.prevent="doRemoveCompany(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--查看方案列表 -->
      <scheme-drawer :visible="dialog.scheme_dialog" :routerInfo="routerInfo" @done="handleScheme"></scheme-drawer>

      <!--查看公司修改 -->
      <company-save :visible="dialog.company_dialog" :echo-id="echoId" @done="handleCompany"></company-save>

      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>
  </div>
</template>

<script>
import { fetchList,doAudit, remove } from '@/api/manage/company'
import SchemeDrawer from './SchemeDrawer'
import CompanySave from './CompanySave'
import PageBar from '@/components/PageBar.vue'
import { handleConfirm } from '@utils/confirm'

export default {
  name: 'ev-company',
  components: {
    PageBar, SchemeDrawer,CompanySave
  },
  created() {
    this.fetchData()
  },
  data: function() {
    return {
      page: {
        pageSize: 20,
        pageNo: 1,
        param:{}
      },
      companyList: [],
      searchFm: {},
      echoId:null,
      dialog: {
        company_dialog: false,
        scheme_dialog: false
      },
      routerInfo: {}
    }
  },
  methods: {
    fetchData() {
      let {pageNo,pageSize,param} = this.page
      fetchList({pageNo,pageSize}).then(resp => {
        let data = resp.data.result
        this.$set(this.page, 'total', data.total)
        this.$set(this.page, 'pageNo', data.pageNo)
        this.$set(this.page, 'pageSize', data.pageSize)
        this.companyList = data.records
      })
    },
    doAudit(id){
      handleConfirm('审核通过后，请及时联系客户公司，开通响应的测评方案！！').then(() => {
        doAudit(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    },
    toAddCompany(data) {
      this.dialog.company_dialog = true
      this.echoId = data
    },
    dosearch(){
      if(this.searchFm.companyName){
        this.page.param = {name:`%${this.searchFm.companyName}%`}
      }
      this.fetchData()
    },
    doRemoveCompany(id) {
      handleConfirm('此操作将删除该公司, 是否继续?').then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    },
    toViewProject(companyId) {
      this.$router.push({ path: `/manage/company/project/list/${companyId}`})
    },
    toFindScheme(data) {
      this.routerInfo.userId = data.userId
      this.routerInfo.name = data.name
      this.dialog.scheme_dialog = true
    },
    handleScheme(){
      this.dialog.scheme_dialog = false
    },
    handleCompany(flag = false){
      this.dialog.company_dialog = false
      if(flag){
        this.fetchData()
      }
    },

  }

}
</script>
